export interface SubProcessor {
  name: string;
  category: string;
  data: string;
  location: string;
  logo?: string;
}

export const subProcessors: SubProcessor[] = [
  {
    name: "OpenAI",
    category: "Transcriptie, structurering en vertaling",
    data: "Audio, tekst en gegenereerde uitvoer tijdens AI-verwerking",
    location: "EU-project; Zero Data Retention voor ondersteunde API-functies",
    logo: "/logos/openai.svg",
  },
  {
    name: "Stripe",
    category: "Betalingen",
    data: "Klant-, abonnements-, factuur- en betaalgegevens",
    location:
      "Ierland (EU); voor een eventuele VS-doorgifte geldt het EU-VS Data Privacy Framework",
    logo: "/logos/stripe.svg",
  },
  {
    name: "Resend",
    category: "Transactionele e-mail",
    data: "E-mailadres van de ontvanger, berichtmetadata en de inhoud van verzonden e-mails",
    location: "Verenigde Staten; EU-VS Data Privacy Framework (adequaatheidsbesluit)",
    logo: "/logos/resend.svg",
  },
  {
    name: "Hetzner",
    category: "Applicatiehosting, database, objectopslag en operationele logging",
    data: "Account-, organisatie-, sessie- en gebruiksgegevens; medische inhoud en versleutelde opnamevelden; applicatieverkeer en technische loggegevens",
    location: "Duitsland (EU): Neurenberg en Falkenstein; geen doorgifte buiten de EER",
    logo: "/logos/hetzner.svg",
  },
  {
    name: "GitLab",
    category: "Broncode, CI/CD en containerregister",
    data: "Broncode, buildmetadata en containerimages",
    location: "Verenigde Staten en andere locaties; geen klant- of patiëntgegevens",
    logo: "/logos/gitlab.svg",
  },
  {
    name: "Expo",
    category: "Registratie van pushtokens voor toekomstige meldingen",
    data: "Pushtoken; de backend verstuurt momenteel geen meldingsinhoud via Expo",
    location: "Verenigde Staten; momenteel geen verzonden pushberichten",
    logo: "/logos/expo.svg",
  },
];
